import * as React from "react";
import ShimmerDashboard from "../../../../Assets/Loaders/ShimmerEffect";

const CommisionURL = process.env.REACT_APP_CommisionURL;
const Commission = ({ agentID }) => {
    const [loader, setLoader] = React.useState(true);

    const [commissionPopup, setCommissionPopup] = React.useState(false);
    React.useEffect(() => {
      window.addEventListener("message", (event) => {
        try {
          const eventData = JSON.parse(event.data);
          if (eventData.hasOwnProperty("isFullScreen")) {
            const isFullScreen = eventData.isFullScreen;
            setCommissionPopup(isFullScreen);
          }
        } catch (error) {
          console.error("Error parsing message data:", error);
        }
      });
    }, []);

  return (
    <div style={commissionPopup ? {
        position: "fixed",
        inset: 0,
        zIndex: 10000
    } : {}}>
      {loader && <div style={{ height: commissionPopup ? "100vh" : 500 }}>
        <ShimmerDashboard onlyTable={true}/>
      </div>}
      <iframe
        src={`${CommisionURL}${btoa(agentID)}`}
        style={{
          ...(commissionPopup ? styleCommission : style),
          display: loader ? "none" : "block"
        }}
        onLoad={() => setLoader(false)}
      />
    </div>
  );
};


export default Commission;

const style = {
  width: "100%",
  height: 500,
  border: "none",
  margin: "auto",
};
const styleCommission = {
  width: "100%",
  height: "100vh",
  border: "none",
  margin: "auto",
};
